
export const timestampToDate = (timestamp: number): Date => {
    return new Date(timestamp * 1000) // JS dùng milliseconds
}

/**
 * Format ngày theo kiểu Việt Nam: DD/MM/YYYY
 */
export const formatDateVN = (timestamp: number): string => {
    const date = timestampToDate(timestamp)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}

/**
 * Format ngày giờ đầy đủ: DD/MM/YYYY lúc HH:mm
 */
export const formatDateTimeVN = (timestamp: number): string => {
    const date = timestampToDate(timestamp)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${day}/${month}/${year} lúc ${hours}:${minutes}`
}

/**
 * Format tương đối: Hôm nay, Hôm qua, hoặc ngày cụ thể
 */
export const formatRelativeDateVN = (timestamp: number): string => {
    const date = timestampToDate(timestamp)
    const now = new Date()
    const diffInDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 3600 * 24))

    if (diffInDays === 0) return 'Hôm nay'
    if (diffInDays === 1) return 'Hôm qua'
    if (diffInDays < 7) return `${diffInDays} ngày trước`

    return formatDateVN(timestamp)
}